import './config.js'

import React from 'react';
// import {withRouter} from 'react-router';
import {
    BrowserRouter as Router,
    Route,
} from 'react-router-dom'
import './App.css';
import ReactClass from 'create-react-class';

import NavbarInstance from './navbar.js';
import PrivateRoute from './private-route.js';
import SignIn from './sign-in.js';
import Admin from './admin.js'
import Projects from './projects.js'
import Project from './project.js'
import MyActions from './myactions.js'
// import AutoSignIn from './auto-sign-in.js'

const Home = () => (
    <div>
        <Projects />
        <MyActions />
    </div>
);


const ProjectPage = ({match}) => (
    <div>
        <Project projectId={match.params.id} actionId={match.params.actionId}/>
    </div>
);


const AppBase = ReactClass({
    componentDidMount() {
    },
    render() {
        return (
            <Router>
                <div>
                    <NavbarInstance />

                    <div className="container">
                        <PrivateRoute exact path="/" component={Home}/>
                        <PrivateRoute exact path="/admin/:page?" component={Admin}/>
                        <PrivateRoute path="/project/:id/:actionId?" component={ProjectPage}/>
                        <Route path="/sign-in" component={SignIn}/>
                    </div>
                </div>
            </Router>
        )
    }
});
// const AppBaseWithRouter = withRouter(AppBase);

export default AppBase //WithRouter


// WEBPACK FOOTER //
// ./src/App.js